// extracted by mini-css-extract-plugin
export default {"editButton":"addLoans_editButton__7WG8-","TableBody":"addLoans_TableBody__6bglL","deleteButton":"addLoans_deleteButton__fU60s"};